import {
  ClientEventsCard,
  ConversationBehaviorCard,
  ExternalToolsCard,
  ModelIntelligenceCard,
  PrivateContextSourceCard,
  UsageBillingCard,
} from "@/components/agent/details";
import { CoreDrawer } from "@/components/common/CoreDrawer";
import { Agent } from "@/types/agent/agent";

interface AdvancedSettingsDrawerProps {
  genie: Agent;
  isOpen: boolean;
  onClose: () => void;
}

export default function AdvancedSettingsDrawer({ genie, isOpen, onClose }: AdvancedSettingsDrawerProps) {
  const brand = genie.branding?.primaryColor ?? "#4E9CFF";

  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Advanced Settings"
      description="Configure AI model, conversation behavior, tools, and more."
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 xl:items-stretch">
        <ModelIntelligenceCard agent={genie} brand={brand} />
        <ConversationBehaviorCard agent={genie} brand={brand} />
        <ExternalToolsCard agent={genie} brand={brand} />
        <ClientEventsCard agent={genie} brand={brand} />
        <PrivateContextSourceCard agent={genie} brand={brand} />
        <UsageBillingCard agent={genie} brand={brand} />
      </div>
    </CoreDrawer>
  );
}
